import React from "react";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";

const StarRating = ({ rating }) => {
  const stars = [];
  for (let i = 1; i <= 5; i += 1) {
    stars.push(
      <span
        key={i}
        style={{ color: i <= rating ? "#f5a623" : "#ccc", fontSize: 18 }}
      >
        ★
      </span>
    );
  }
  return <span>{stars}</span>;
};

const ReviewTable = ({ reviews, onDelete, showProduct = false }) => {
  if (!reviews.length) {
    return (
      <Typography variant="body2" color="textSecondary" style={{ padding: 16 }}>
        No customer reviews yet.
      </Typography>
    );
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Reviewer</TableCell>
          {showProduct && <TableCell>Product</TableCell>}
          <TableCell>Rating</TableCell>
          <TableCell>Title</TableCell>
          <TableCell>Comment</TableCell>
          <TableCell>Date</TableCell>
          <TableCell align="right">Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {reviews.map((review) => (
          <TableRow key={review.id}>
            <TableCell>
              <Typography variant="body2">{review.reviewer_name}</Typography>
              {review.is_deleted_user ? (
                <Typography variant="caption" color="textSecondary">
                  Former account
                </Typography>
              ) : (
                <Typography variant="caption" color="textSecondary">
                  {review.reviewer_email}
                </Typography>
              )}
            </TableCell>
            {showProduct && (
              <TableCell>
                {review.product_slug ? (
                  <Link to={`/edit-product/${review.product_slug}`}>
                    {review.product_name}
                  </Link>
                ) : (
                  <Typography variant="body2">{review.product_name}</Typography>
                )}
              </TableCell>
            )}
            <TableCell>
              <StarRating rating={review.rating} />
            </TableCell>
            <TableCell>{review.title || "—"}</TableCell>
            <TableCell style={{ maxWidth: 320 }}>
              <Typography variant="body2" style={{ whiteSpace: "pre-wrap" }}>
                {review.comment}
              </Typography>
            </TableCell>
            <TableCell>
              {moment(review.created_at).format("MMM D, YYYY")}
            </TableCell>
            <TableCell align="right">
              <IconButton
                size="small"
                aria-label="Delete review"
                onClick={() => onDelete(review.id)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export { StarRating, ReviewTable };
